export default __webpack_public_path__ + "static/media/sanitario_content.cfe8ac7a.jpg";